import filter from "./filter.js";

export default filter((a) => a);
